import type { BuxusPreviewAlertOutput, BuxusSendAlertDto, BuxusSendAlertOutput } from '@buxus/shared'
import {
  BUXUS_PREVIEW_ALERT_URL,
  BUXUS_SEND_ALERT_URL,
  BUXUS_WEBHOOK_TOKEN,
} from '../../platform/abp/config'
import { httpJson } from '../../platform/abp/httpClient'

export async function postPreviewAlert(dto: BuxusSendAlertDto): Promise<BuxusPreviewAlertOutput> {
  const body = { ...dto, token: dto.token || BUXUS_WEBHOOK_TOKEN }
  return httpJson<BuxusPreviewAlertOutput>(BUXUS_PREVIEW_ALERT_URL, {
    method: 'POST',
    auth: true,
    body,
  })
}

export async function postSendAlert(dto: BuxusSendAlertDto): Promise<BuxusSendAlertOutput> {
  const body = { ...dto, token: dto.token || BUXUS_WEBHOOK_TOKEN }
  return httpJson<BuxusSendAlertOutput>(BUXUS_SEND_ALERT_URL, {
    method: 'POST',
    auth: true,
    body,
  })
}
